import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { latitude, longitude } from '~/prix/types/presets/geo'
import sql from '~/prix/utils/sql'

export const trainingPerformedObject = z.object({
  id: z.string().uuid(),
  trainingId: z.string().uuid(),
  startDate: dateOrIsoString().nullish(),
  endDate: dateOrIsoString().nullish(),
  location: z.string().nullish(),
  latitude: latitude().nullish(),
  longitude: longitude().nullish(),
  fullAddress: z.string().nullish(),
  trainer: z.string().nullish(),
  participants: z.number().int().nullish(),
  hours: z.number().int().nullish(),
  sourceFilter: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type TrainingPerformedType = z.infer<typeof trainingPerformedObject>

export const propertyMap = {
  id: sql`training_performed.id`,
  trainingId: sql`training_performed.training_id`,
  startDate: sql`training_performed.start_date`,
  endDate: sql`training_performed.end_date`,
  location: sql`training_performed.location`,
  latitude: sql`training_performed.latitude`,
  longitude: sql`training_performed.longitude`,
  fullAddress: sql`training_performed.full_address`,
  trainer: sql`training_performed.trainer`,
  participants: sql`training_performed.participants`,
  hours: sql`training_performed.hours`,
  sourceFilter: sql`training_performed.source_filter`,
  createdAt: sql`training_performed.created_at`,
  updatedAt: sql`training_performed.updated_at`,
  deletedAt: sql`training_performed.deleted_at`,
}

export default trainingPerformedObject
